import { KeyValueStore } from '@frontend/utils';

const KEY = 'pushNotificationToken';

export interface PushNotificationStorageValue {
  hashedToken: string;
  createdAt: Date;
}

export const PushNotificationTokenStorage = {
  async get(): Promise<PushNotificationStorageValue | undefined> {
    const storedValue = await KeyValueStore.get(KEY);

    if (!storedValue) {
      return undefined;
    }

    return JSON.parse(storedValue, (key, value) => {
      if (key === 'createdAt') {
        return new Date(value);
      }

      return value;
    }) as PushNotificationStorageValue;
  },

  async set(value: PushNotificationStorageValue): Promise<void> {
    await KeyValueStore.set(KEY, JSON.stringify(value));
  },

  async remove(): Promise<void> {
    await KeyValueStore.remove(KEY);
  },
};
